export default {
  created() {
    window.userId = this.$auth.user?.id
  },
  beforeDestroy() {
    delete window.userId
  }
}
